angular.module('leanlaw').controller('ReceivablesReportSidebarCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);